module.exports = __webpack_public_path__ + "static/NightInTheWoods4-316ccccc3594fdcdbc5f540b9bc10fe8.webp";